"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var definitions_1 = require("./definitions");
var filter_1 = require("./filter");
/**
 * =============================================================================
 * Leaf Filter represents a single query
 * @param on       string
 * @param values   Array<string>
 * @param range    Range {gt: value}
 * @param search   string
 * @param hasValue boolean
 * =============================================================================
 */
var LeafFilter = /** @class */function (_super) {
  __extends(LeafFilter, _super);
  function LeafFilter(on) {
    var _this = _super.call(this) || this;
    _this.on = on;
    _this.values = [];
    _this.search = '';
    return _this;
  }
  /**
   * Change the property this filter operates on
   * @param  on String to identify the property to execute this on
   * @return    void
   */
  LeafFilter.prototype.setOn = function (on) {
    this.on = on;
    this.updated.next(this);
    return this;
  };
  /**
   * Get the property this filter operates on
   * @return string
   */
  LeafFilter.prototype.getOn = function () {
    return this.on;
  };
  /**
   * Values: Use values to look for one or more matches
   * @param values Array<string | number>
   */
  LeafFilter.prototype.setValues = function (values) {
    this.values = values || [];
    this.updated.next(this);
    return this;
  };
  /**
   * Values: Use values to look for one or more matches
   * @return Array<string | number>
   */
  LeafFilter.prototype.getValues = function () {
    return this.values;
  };
  /**
   * Range to query by
   * @param range Range
   */
  LeafFilter.prototype.setRange = function (range, silent) {
    if (silent === void 0) {
      silent = false;
    }
    this.range = __assign({}, range);
    var clean = function (rangeObj) {
      if (rangeObj) {
        if (rangeObj.reference === null) {
          delete rangeObj.reference;
        }
        if (rangeObj.unit === null) {
          delete rangeObj.unit;
        }
        if (rangeObj.includeValue === null) {
          rangeObj.includeValue = false;
        }
      }
    };
    clean(this.range.gt);
    clean(this.range.lt);
    if (!silent) {
      this.updated.next(this);
    }
    return this;
  };
  /**
   * Range to query by
   * @return Range
   */
  LeafFilter.prototype.getRange = function () {
    return this.range;
  };
  /**
   * Search term to search for a string
   * @param search string
   */
  LeafFilter.prototype.setSearch = function (search) {
    this.search = search;
    this.updated.next(this);
    return this;
  };
  /**
   * Search term to search for a string
   * @return string
   */
  LeafFilter.prototype.getSearch = function () {
    return this.search ? this.search : undefined; // we don't want empty strings...
  };
  /**
   * Use hasValue to check if any value exists at all
   * @param value boolean
   */
  LeafFilter.prototype.setHasValue = function (value) {
    this.hasValue = value;
    return this;
  };
  /**
   * Use hasValue to check if any value exists at all
   * @return boolean
   */
  LeafFilter.prototype.getHasValue = function () {
    return this.hasValue;
  };
  /**
   * Sort and exclude values can be overwritten via parametrization
   */
  /**
   * Reset all Criteria of this filter to defaults, keeps only the ON value and ID intact
   * @param notify Send an update to the onChanged subscribers. Defaults to false
   * @param resetSort Reset the sort criteria. Defaults to false
   * @param resetExcludes Reset the exclude flag to false. Defaults to false (= do not change)
   */
  LeafFilter.prototype.reset = function (notify, resetSort, resetExcludes) {
    if (notify === void 0) {
      notify = false;
    }
    if (resetSort === void 0) {
      resetSort = false;
    }
    if (resetExcludes === void 0) {
      resetExcludes = false;
    }
    this.range = {};
    this.values = [];
    this.search = '';
    this.hasValue = undefined;
    if (resetSort) {
      this.setSort([]);
    }
    if (resetExcludes) {
      this.setExclude(false);
    }
    if (notify) {
      this.updated.next(this);
    }
  };
  LeafFilter.prototype.hasRange = function () {
    return this.range.gt !== undefined || this.range.lt !== undefined;
  };
  /**
   * Convert this filter object to a plain JSON object in IqlLeafQuery format
   * @return JSON<IqlLeafQuery>
   */
  LeafFilter.prototype.toJson = function (clean) {
    if (clean === void 0) {
      clean = false;
    }
    // check if these values are valid. range is different, there always is a range by nature
    var ret = __assign({}, _super.prototype.toJson.call(this), {
      on: this.getOn(),
      values: this.values && this.values.length ? this.values : undefined,
      range: this.range && this.hasRange() ? this.range : undefined,
      search: this.search && this.search.length ? this.search : undefined,
      hasValue: this.hasValue
    });
    Object.keys(ret).forEach(function (key) {
      if (ret[key] === null || ret[key] === undefined) {
        delete ret[key];
      } else if (Array.isArray(ret[key]) && ret[key].length === 0) {
        delete ret[key];
      }
    });
    // if clean and nothing defined, return undefined instead of an object
    if (clean && !ret.range && !ret.search && !ret.sort && !ret.values && ret.hasValue === undefined) {
      return undefined;
    }
    return ret;
  };
  /**
   * toJson convert this filter object to a plain JSON object
   * @return    Object JSON representation of this filter
   */
  LeafFilter.prototype.toQueryString = function () {
    var sort = _super.prototype.toQueryString.call(this);
    var id = this.getIdentifier() || '';
    var on = this.getOn();
    var filterControls = "" + on + definitions_1.filterControl + id + definitions_1.filterControl + sort;
    var qs;
    if (this.values && this.values.length) {
      qs = "v" + definitions_1.filterControl + filterControls + definitions_1.leafBegin + this.values.map(function (v) {
        return "" + definitions_1.quoteMark + v + definitions_1.quoteMark;
      }).join(definitions_1.valueSeparator) + definitions_1.leafEnd;
    } else if (this.range && this.hasRange()) {
      qs = "r" + definitions_1.filterControl + filterControls + definitions_1.leafBegin + (this.range.gt && this.range.gt.includeValue ? 'i:' : '') + (this.rangeSerialization(this.range.gt) || '') + definitions_1.valueSeparator + (this.range.lt && this.range.lt.includeValue ? 'i:' : '') + (this.rangeSerialization(this.range.lt) || '') + definitions_1.leafEnd;
    } else if (this.search && this.search.length) {
      if (this.search.startsWith('"') && this.search.endsWith('"')) {
        var searchString = this.search.replace(/^"|"$/g, '');
        qs = "c" + definitions_1.filterControl + filterControls + definitions_1.leafBegin + definitions_1.quoteMark + searchString + definitions_1.quoteMark + definitions_1.leafEnd;
      } else {
        qs = "s" + definitions_1.filterControl + filterControls + definitions_1.leafBegin + definitions_1.quoteMark + this.search + definitions_1.quoteMark + definitions_1.leafEnd;
      }
    } else if (this.hasValue || this.hasValue === false) {
      qs = "e" + definitions_1.filterControl + filterControls + definitions_1.leafBegin + (this.hasValue ? 'true' : 'false') + definitions_1.leafEnd;
    } else {
      // SLIGHTLY hacky...
      // if a filter has no other values set, translate the URL version
      // to a "SEARCH empty string"
      qs = "s" + definitions_1.filterControl + filterControls + definitions_1.leafBegin + definitions_1.leafEnd;
    }
    return "" + (this.exclude ? definitions_1.filterNegate : '') + qs;
  };
  /**
   * Convert this filter object to a Human readable format
   * @return     string
   */
  LeafFilter.prototype.toHumanReadable = function () {
    var _this = this;
    var filterString = function () {
      if (_this.values && _this.values.length) {
        return _this.on + " IN [" + _this.values.map(function (val) {
          return _this.isNumDefined(val) ? val : "" + definitions_1.quoteMark + val + definitions_1.quoteMark;
        }).join(definitions_1.HRvalueSeparator) + "]";
      } else if (_this.range && _this.hasRange()) {
        // this is a destructive operation!
        // our filter can have two or more conditions stored
        // but the HR syntax supports only one.
        // We prioritize in this way:
        var ltPart = void 0;
        if (_this.range.lt) {
          ltPart = _this.on + " <" + (_this.range.lt.includeValue ? '=' : '') + " " + _this.rangeSerialization(_this.range.lt);
        }
        if (_this.range.gt) {
          return ltPart ? _this.rangeSerialization(_this.range.gt) + " <" + (_this.range.gt.includeValue ? '=' : '') + " " + ltPart : _this.on + " >" + (_this.range.gt.includeValue ? '=' : '') + " " + _this.rangeSerialization(_this.range.gt);
        } else {
          return ltPart;
        }
      } else if (_this.search && _this.search.length) {
        if (_this.search.startsWith('"') && _this.search.endsWith('"') && _this.search.length >= 2) {
          var searchString = _this.search.replace(/^"|"$/g, '');
          return _this.on + " CONTAINS " + definitions_1.quoteMark + searchString + definitions_1.quoteMark;
        }
        return _this.on + " ~ " + definitions_1.quoteMark + _this.search + definitions_1.quoteMark;
      } else if (_this.hasValue) {
        return _this.on + " EXISTS";
      }
    }();
    var id = this.getIdentifier() ? " " + definitions_1.HRfilterID + " " + this.getIdentifier() : '';
    return "" + (this.getExclude() ? definitions_1.HRfilterNegate : '') + filterString + _super.prototype.toHumanReadable.call(this) + id;
  };
  /**
   * Clones the Current LeafFilter
   * @return LeafFilter
   */
  LeafFilter.prototype.clone = function () {
    var clone = new LeafFilter(this.getOn()).setIdentifier(this.getIdentifier()).setSearch(this.getSearch()).setRange(this.getRange()).setValues(this.getValues()).setHasValue(this.getHasValue()).setSort(this.getSort()).setExclude(this.getExclude());
    return clone;
  };
  LeafFilter.prototype.equals = function (other, ignoreSort) {
    if (ignoreSort === void 0) {
      ignoreSort = false;
    }
    // Make sure the other is a LEAF as well
    if (!other.on) {
      return false;
    }
    // Check all the basics
    if (!_super.prototype.equals.call(this, other, ignoreSort)) {
      return false;
    }
    // Make sure we look at the same property
    if (this.getOn() !== other.getOn()) {
      return false;
    }
    // Make sure that the different values are the same (if any)
    if (this.getSearch() !== other.getSearch()) {
      return false;
    }
    // Make sure that the different values are the same (if any)
    if (!!this.getHasValue() !== !!other.getHasValue()) {
      return false;
    }
    // Make sure that the different values are the same (if any)
    if (!this.compareRange(other)) {
      return false;
    }
    // Make sure that the different values are the same (if any)
    if (!this.compareValues(other)) {
      return false;
    }
    return true;
  };
  LeafFilter.prototype.isNumDefined = function (val) {
    if (val === undefined || val === null) {
      return false;
    }
    if (Object.keys(val).length) {
      var range = val;
      return range.value >= 0 || range.value <= 0;
    }
    return val >= 0 || val <= 0;
  };
  LeafFilter.prototype.rangeSerialization = function (val) {
    if (!val) {
      return '';
    }
    if (Object.keys(val).length) {
      var range = val;
      return "" + (range.reference ? range.reference + ' ' : '') + (range.reference ? range.value < 0 ? '- ' : '+ ' : '') + (range.reference ? Math.abs(range.value) : range.value) + (range.unit || '');
    }
    return val;
  };
  LeafFilter.prototype.compareRange = function (other) {
    var ours = this.getRange() || {};
    var theirs = other.getRange() || {};
    if (!!ours && !!theirs) {
      return (!ours.lt && !theirs.lt || ours.lt && theirs.lt && ours.lt.value === theirs.lt.value) && (!ours.gt && !theirs.gt || ours.gt && theirs.gt && ours.gt.value === theirs.gt.value) && (!ours.lt && !theirs.lt || ours.lt && theirs.lt && ours.lt.reference === theirs.lt.reference) && (!ours.gt && !theirs.gt || ours.gt && theirs.gt && ours.gt.reference === theirs.gt.reference) && (!ours.lt && !theirs.lt || ours.lt && theirs.lt && ours.lt.unit === theirs.lt.unit) && (!ours.gt && !theirs.gt || ours.gt && theirs.gt && ours.gt.unit === theirs.gt.unit);
    }
    return false;
  };
  LeafFilter.prototype.compareValues = function (other) {
    if (!this.getValues()) {
      return !other.getValues();
    }
    if (!other.getValues()) {
      return false;
    }
    // custom array compare without lodash
    if (this.getValues().length !== other.getValues().length) {
      return false;
    }
    var ours = this.getValues().slice().sort(function (a, b) {
      return a.toString().localeCompare(b.toString());
    });
    var theirs = other.getValues().slice().sort(function (a, b) {
      return a.toString().localeCompare(b.toString());
    });
    return ours.reduce(function (result, current, index) {
      return result && current === theirs[index];
    }, true);
  };
  return LeafFilter;
}(filter_1.Filter);
exports.LeafFilter = LeafFilter;